import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import React from 'react';
import SafeDrivingGuideBottomSheetEu from '@di-shared/features/safe-driving/eu/SafeDrivingGuideBottomSheet.eu';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 1000;

function SafeDrivingGuideBottomSheetPage() {
  const {fromDate, toDate} = (window as any).data as {fromDate: string; toDate: string};
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingGuideBottomSheetEu
        fromDate={fromDate}
        toDate={toDate}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingGuideBottomSheetPage;
